import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Address } from 'src/app/interfaces/common/address.interface';
import { Area } from 'src/app/interfaces/common/area.interface';
import { Division } from 'src/app/interfaces/common/division.interface';
import { Zone } from 'src/app/interfaces/common/zone.interface';
import { FilterData } from 'src/app/interfaces/core/filter-data';
import { AreaService } from 'src/app/services/common/area.service';
import { DivisionService } from 'src/app/services/common/division.service';
import { UserDataService } from 'src/app/services/common/user-data.service';
import { ZoneService } from 'src/app/services/common/zone.service';
import { ReloadService } from 'src/app/services/core/reload.service';
import { UiService } from 'src/app/services/core/ui.service';
import {User} from '../../../interfaces/common/user.interface';

@Component({
  selector: 'app-manage-address',
  templateUrl: './manage-address.component.html',
  styleUrls: ['./manage-address.component.scss']
})
export class ManageAddressComponent implements OnInit, OnDestroy {

  // Store Data
  storeAddress: string;
  showAddressForm: boolean = false;
  addresses: Address[];
  divisions: Division[] = [];
  area: Area[] = [];
  zone: Zone[] = [];
  dataForm: FormGroup;
  selectEdittedAdress: Address | any = null;
  getDefaultAdress: Address | any = null;

  // Loader Data
  isLoading = false;
  isSelected = false;
  user: User = null;

  // Subscriptions
  private subGetData1: Subscription;
  private subGetData2: Subscription;
  private subGetData3: Subscription;
  private subGetData4: Subscription;
  private subUpdateData1: Subscription;
  private subDeleteData1: Subscription;
  private subFormData: Subscription;
  private subReloadData1: Subscription;

  // Inject
  private readonly fb = inject(FormBuilder);
  private readonly uiService = inject(UiService);
  private readonly divisionService = inject(DivisionService);
  private readonly areaService = inject(AreaService);
  private readonly zoneService = inject(ZoneService);
  private readonly userDataService = inject(UserDataService);
  private readonly reloadService = inject(ReloadService);


  ngOnInit(): void {

    this.subReloadData1 = this.reloadService.refreshData$.subscribe(() => {
      this.getUserAddress();
    })

    this.initForm();

    // Base Data
    this.getAllDivision();
    this.getUserAddress();
    // this.getLoggedInUserInfo();

  }

  /**
   * INITIALIZE FORM FUNCTION
   * initForm()
   * onFormSubmit()
   */
  initForm() {
    this.dataForm = this.fb.group({
      name: [null, Validators.required],
      phone: [null, [Validators.required, Validators.maxLength(13),Validators.minLength(10)]],
      division: [null, Validators.required],
      area: [null, Validators.required],
      zone: [null, Validators.required],
      address: [null, [Validators.required]],
      addressType: [null],
      setDefaultAddress: [false]
    });
  }

  onFormSubmit() {
    if (this.dataForm.valid) {
      let selectDivision = this.divisions.find((d) => d._id === this.dataForm.value.division);
      let selectArea = this.area.find((d) => d._id === this.dataForm.value.area);
      let selectZone = this.zone.find((d) => d._id === this.dataForm.value.zone);
      const mData = {
        ...this.dataForm.value,
        ...{ division: selectDivision },
        ...{ area: selectArea },
        ...{ zone: selectZone },
      }
      if (mData) {
        if (this.selectEdittedAdress === null) {
          this.addAddress(mData);
        } else {
          this.updateAddress(this.selectEdittedAdress?._id, mData);
        }
      }
    }
    else {
      this.uiService.success('Please fill all form input');
      this.dataForm.markAllAsTouched();
    }
  }


  /***
   * HTTP REQUEST HANDLE
   * getAllDivision()
   * getAllArea()
   * getAllZone()
   * addAddress()
   * getUserAddress()
   *
   */



  private getLoggedInUserInfo() {
    this.subGetData1 = this.userDataService.getLoggedInUserData()
      .subscribe({
          next: res => {
            if (res) {
              this.user = res.data;
              this.dataForm.patchValue(this.user);
              this.dataForm.patchValue({phone: this.user?.phoneNo});
              this.dataForm.patchValue({ division: this.user?.division?._id });
              this.dataForm.patchValue({ area: this.user?.area?._id });
              this.dataForm.patchValue({ zone: this.user?.zone?._id });
              this.getAllArea(this.dataForm.get('division')?.value);
              this.getAllZone(this.dataForm.get('area')?.value);

            }
          },
          error: err => {
            console.log(err);
          }
        }
      );
  }
  private getAllDivision() {
    let mSelect = {
      name: 1,
    }
    const filter: FilterData = {
      filter: { status: 'publish' },
      select: mSelect,
      pagination: null,
      sort: { createdAt: -1 }
    }

    this.subGetData1 = this.divisionService.getAllDivisions(filter).subscribe({
      next: res => {
        if (res.success) {
          this.divisions = res.data;
        }
      },
      error: err => {
        console.log(err);
      }
    })
  }

  private getAllArea(id: string) {
    const select = 'name';
    this.subGetData2 = this.areaService.getAreaByParentId(id, select).subscribe({
      next: res => {
        if (res.success) {
          this.area = res.data;
        }
      },
      error: err => {
        console.log(err);
      }
    })
  }

  private getAllZone(id: string) {
    const select = 'name';
    this.subGetData3 = this.zoneService.getZoneByParentId(id, select).subscribe({
      next: res => {
        if (res.success) {
          this.zone = res.data;
        }
      },
      error: err => {
        console.log(err);
      }
    })
  }

  private addAddress(data: Address) {
    this.isLoading = true;
    this.subFormData = this.userDataService.addAddress(data).subscribe({
      next: res => {
        if (res) {
          this.isLoading = false;
          this.uiService.success('Address Added');
          this.reloadService.needRefreshData$();
          this.showAddressForm = false;
        }
      },
      error: err => {
        this.isLoading = false;
        console.log(err);
      }
    })
  }

  private getUserAddress() {
    this.subGetData4 = this.userDataService.getUserAddress().subscribe({
      next: res => {
        if (res.success) {
          this.addresses = res.data;

          this.getDefaultAdress  = this.addresses.find(f => f.setDefaultAddress === true);
          this.dataForm.patchValue({ division: this.getDefaultAdress?.division?._id });
          this.dataForm.patchValue({ area: this.getDefaultAdress?.area?._id });
          this.dataForm.patchValue({ zone: this.getDefaultAdress?.zone?._id });
          this.getAllArea(this.dataForm.get('division')?.value);
          this.getAllZone(this.dataForm.get('area')?.value);
        }
      },
      error: err => {
        console.log(err);
      }
    }
    )
  }

  public deleteAddressById(id: string) {
    this.subDeleteData1 = this.userDataService.deleteAddressById(id).subscribe({
      next: res => {
        if (res) {
          this.reloadService.needRefreshData$();
          this.uiService.success(res.message);
        }
      },
      error: err => {
        console.log(err);
      }
    })
  }

  public setDefualtAddress(id: string) {
    const data = {
      setDefaultAddress: true
    };
    this.subUpdateData1 = this.userDataService.editAddress(id, data).subscribe({
      next: res => {
        if (res) {
          this.reloadService.needRefreshData$();
          this.uiService.success(res.message);
          this.removeOthorDefualtAddress(id);
        }
      },
      error: err => {
        console.log(err);
      }
    })
  }

  private updateAddress(id: string, data: Address) {
    this.subUpdateData1 = this.userDataService.editAddress(id, data).subscribe({
      next: res => {
        if (res) {
          this.reloadService.needRefreshData$();
          this.uiService.success(res.message);
          this.showAddressForm = false;
        }
      },
      error: err => {
        console.log(err);
      }
    })
  }

  private removeOthorDefualtAddress(id: string) {
    for (let i = 0; i < this.addresses.length; i++) {
      if (id !== this.addresses[i]._id) {
        const data = {
          setDefaultAddress: false
        };
        this.subUpdateData1 = this.userDataService.editAddress(this.addresses[i]._id, data).subscribe({
          next: res => {
            if (res) {
              this.reloadService.needRefreshData$();
            }
          },
          error: err => {
            console.log(err);
          }
        })
      }
    }
  }

  public onSelectEdittedAddress(address: Address) {
    if (address) {
      this.selectEdittedAdress = address;
      this.isSelected = true;
      if (this.selectEdittedAdress !== null) {
        this.dataForm.patchValue(this.selectEdittedAdress);
        this.dataForm.patchValue({ division: this.selectEdittedAdress?.division?._id });
        this.dataForm.patchValue({ area: this.selectEdittedAdress?.area?._id });
        this.dataForm.patchValue({ zone: this.selectEdittedAdress?.zone?._id });
        this.getAllArea(this.dataForm.get('division')?.value);
        this.getAllZone(this.dataForm.get('area')?.value);
        this.storeAddress = this.selectEdittedAdress?.addressType;
        this.showAddressForm = true;
      }
    }

  }

  /***
   * ON SELECT CHANGE
   * onChangeRegion()
   * onChangeArea()
   */
  onChangeRegion(event: any) {
    if (event) {
      this.getAllArea(event?._id);
      this.dataForm.get('division')?.patchValue(event?._id);
    }
  }

  onChangeArea(event: any) {
    if (event) {
      this.getAllZone(event?._id);
      this.dataForm.get('area')?.patchValue(event?._id);
    }
  }

  onChangeZone(event: any) {
    if (event) {
      this.dataForm.get('zone')?.patchValue(event?._id);
    }
  }

  /**
   * ADDRESS SELECT AND SHOW ADDRESS FORM FUNCTIONS
   * onAddressSelect();
   * onShowAddressForm();
   */
  onAddressSelect(address: string) {
    this.storeAddress = address;
    this.dataForm.patchValue({ addressType: address })
  }

  onShowAddressForm() {
    this.showAddressForm = true;
    this.getLoggedInUserInfo()
  }


  /**
   * SHOW AND HIDE POPUP FUNCTION
   * onHideShowPopup()
   */
  onHideShowPopup() {
    this.showAddressForm = false;
  }

  /***
   * On Destroy
   */
  ngOnDestroy(): void {
    if (this.subGetData1) {
      this.subGetData1.unsubscribe();
    }
    if (this.subGetData2) {
      this.subGetData2.unsubscribe();
    }
    if (this.subGetData3) {
      this.subGetData3.unsubscribe();
    }
    if (this.subGetData4) {
      this.subGetData4.unsubscribe();
    }
    if (this.subUpdateData1) {
      this.subUpdateData1.unsubscribe();
    }
    if (this.subDeleteData1) {
      this.subDeleteData1.unsubscribe();
    }
    if (this.subFormData) {
      this.subFormData.unsubscribe();
    }
    if (this.subReloadData1) {
      this.subReloadData1.unsubscribe()
    }
  }

}
